import React from 'react';

import styled, { css } from 'styled-components';

export const ColumnsSectionContainer = ({
    numberOfColumns,
    children,
}: {
    numberOfColumns: number;
    children: React.ReactNode;
}) => {
    return <Container $numberOfColumns={numberOfColumns}>{children}</Container>;
};

const Container = styled.div<{ $numberOfColumns: number }>`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    & > * {
        ${({ $numberOfColumns }) => css`
            width: calc(
                (100% - ${20 * ($numberOfColumns - 1)}px) / ${$numberOfColumns}
            ); // There are (numberOfColumns - 1) margin-lefts to spread over numberOfColumns columns
        `};
    }

    & > :not(:nth-child(${({ $numberOfColumns }) => $numberOfColumns}n + 1)) {
        margin-left: 20px;
    }

    & > :nth-child(n + ${({ $numberOfColumns }) => $numberOfColumns + 1}) {
        margin-top: 15px;
    }
`;
